import coinbaseWalletModule from "@web3-onboard/coinbase";

export default coinbaseWalletModule({ darkMode: true });
